import * as moment from "moment";

interface IGoalTimeDetails {
    goalName: string;
    currentMoment: moment.Moment;
    goalTimeMoment: moment.Moment;
    isGoalNameTimeValid: boolean | null;
    timeString: string;
    doesGoalNameHaveBefore: boolean;
    timeDifferenceInMinutes: number;
    isActive: boolean;
    isNotStartedYet?: boolean;
}

export function GetGoalTimeDetails(
    goalName: string,
    currentMoment: moment.Moment
) {
    var goalTimeDetails: Partial<IGoalTimeDetails> = {
        goalName,
        currentMoment,
        isGoalNameTimeValid: IsGoalNameTimeValid(goalName),
        timeString: GetTimeStringFromGoalName(goalName),
    };

    if (!goalTimeDetails.isGoalNameTimeValid) {
        return goalTimeDetails;
    }

    goalTimeDetails.doesGoalNameHaveBefore = IsGoalNameBefore(goalName);
    goalTimeDetails.goalTimeMoment = moment(goalTimeDetails.timeString, "LT");

    goalTimeDetails.timeDifferenceInMinutes = currentMoment.diff(
        goalTimeDetails.goalTimeMoment,
        `minutes`
    );

    goalTimeDetails.isActive = goalTimeDetails.doesGoalNameHaveBefore
        ? goalTimeDetails.timeDifferenceInMinutes <= 0
        : goalTimeDetails.timeDifferenceInMinutes >= 0;

    goalTimeDetails.isNotStartedYet =
        goalTimeDetails.doesGoalNameHaveBefore === false &&
        goalTimeDetails.timeDifferenceInMinutes < 0;

    return goalTimeDetails;
}

function IsGoalNameTimeValid(goalName: string) {
    const isGoalNameTimeApplicable =
        goalName.toLowerCase().includes(`before`) ||
        goalName.toLowerCase().includes(`after`) ||
        goalName.toLowerCase().includes(`until`);

    if (!isGoalNameTimeApplicable) {
        return null;
    }

    const matches = GetTimeStringMatches(goalName);

    if (!matches) {
        return false;
    }

    const timeValue = parseInt(matches[3]);
    return timeValue > 0 && timeValue <= 12;
}

function GetTimeStringFromGoalName(goalName: string) {
    const matches = GetTimeStringMatches(goalName);

    if (matches == null) {
        return undefined;
    }

    return matches[2];
}

function IsGoalNameBefore(goalName: string) {
    const matches = GetTimeStringMatches(goalName);

    if (matches == null) {
        return undefined;
    }

    return matches[1].toLowerCase() === `before`;
}

function GetTimeStringMatches(goalName: string) {
    const expression = new RegExp(/.*(before|after|until)((.*)(am|pm))/gim);
    const matches = expression.exec(goalName);

    if (matches == null) {
        return undefined;
    }

    return matches;
}
